import { render, staticRenderFns } from "./FloatingMenu.vue?vue&type=template&id=ea0a3e12"
import script from "./FloatingMenu.vue?vue&type=script&lang=js"
export * from "./FloatingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports